import {
  BREAKPOINTS,
  buttonStyles,
  colorVariables,
  fontVariables,
  formFieldStyles,
  gridSpacingVariables,
  radiusVariables,
  smallBreakpointFontVariables,
} from '@zoe/ds-web'
import { DSGlobalStyles } from '@zoe/ds-web/next-gen'
import Head from 'next/head'
import type { ReactNode } from 'react'
import { createGlobalStyle } from 'styled-components'

import { AttributionProvider } from '@/context/attributionContext'

import { visuallyHiddenStyles } from '@/styles/globalStyles'

const EmbeddedLegacyDesignSystemVariables = createGlobalStyle`
  :root {
    ${fontVariables}
    ${colorVariables}
    ${gridSpacingVariables}
    ${radiusVariables}
    ${formFieldStyles}
    ${buttonStyles}
  }

  @media screen and (max-width: ${BREAKPOINTS.m}) {
    :root {
      ${smallBreakpointFontVariables}
    }
  }

  .visually-hidden {
    ${visuallyHiddenStyles}
  }
`

interface EmbeddedMobileAppLayoutProps {
  children: ReactNode
}

export const EmbeddedMobileAppLayout = ({ children }: EmbeddedMobileAppLayoutProps) => (
  <AttributionProvider>
    <Head>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
    <DSGlobalStyles />
    <EmbeddedLegacyDesignSystemVariables />
    {children}
  </AttributionProvider>
)
